import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CampaignBranchEntity } from '../../domain/entities/CampaignBranchEntity'

export class CampaignBranchModel extends CampaignBranchEntity {
  branchId!: number
  constructor(dataDto: CampaignBranchEntity) {
    super()
    mapEntityProperties<CampaignBranchModel>(this, dataDto, {
      map: {
        branchId: dataDto.branch?.id
      }
    })
  }
}
